import { Tooltip } from '@material-ui/core';
import React from 'react';

interface HintProps {
  hint: string;
}
class Hint extends React.Component<HintProps> {
  render() {
    const { hint } = this.props;
    if (!hint) {
      return null;
    }
    return (
      <Tooltip title={hint} position="top">
        <span>
          <svg
            x={0}
            y={0}
            width={16}
            height={20}
            viewBox="0 0 24 24"
            className=" m-l-5 m-r-5"
            style={{ marginBottom: -3, paddingTop: 3 }}
          >
            <g>
              <path
                fill="none"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                d="M11.9852,0.6578 c-6.2414,0-11.3179,5.0765-11.3179,11.3179c0,6.2405,5.0765,11.3179,11.3179,11.3179c6.2405,0,11.3179-5.0774,11.3179-11.3179 C23.3032,5.7343,18.2257,0.6578,11.9852,0.6578z"
              />

              <line
                fill="none"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                x1="11.5217"
                y1="18.5817"
                x2="11.5217"
                y2="18.2197"
              />
              <path
                fill="none"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.5217,15.6197v-2.1966 c0-0.3404,0.2189-0.6422,0.5449-0.7578c1.9837-0.7039,3.6352-1.7767,3.6352-3.6005c0-1.9886-1.8346-3.6006-4.0977-3.6006 -1.5238,0-2.8534,0.7309-3.5594,1.8155"
              />
            </g>
          </svg>
        </span>
      </Tooltip>
    );
  }
}

export default Hint;
